import disclaimerData from './disclaimers';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import './idx-reqs.scss';

class IdxReqs extends Component {
  getDisclaimers = () => {
    let mlsOrgs = this.props.mlsOrgs;
    let listing = this.props.listing;
    if (listing && listing.mlsOrg) {
      return disclaimerData.filter( (d) => {
        return d.mlsOrg === listing.mlsOrg;
      }).map( (x) => {
        return this.mapDisclaimerData(x, 'detail');
      });
    } else if (mlsOrgs && mlsOrgs.length > 0) {
      return disclaimerData.filter( (d) => {
        return mlsOrgs.indexOf(d.mlsOrg) !== -1;
      }).map( (x) => {
        return this.mapDisclaimerData(x, 'search');
      });
    }
  }

  mapDisclaimerData = (data, page) => {
    if (page === 'search' && data.searchDisclaimer === null) {
      return null;
    }
    const imageUrl = data.image;
    return (
      <p key={data.mlsOrg}>
        { data.image && data.link ?
          <a href={data.link}>
            <img src={imageUrl} alt={data.mlsOrg + '-mls'} /> 
          </a>
          : null
        }
        {
          data.image && !data.link ? <img src={imageUrl} alt={data.mlsOrg + '-mls'} /> : null
        }
        { page === 'search' ? 
          <span dangerouslySetInnerHTML={{__html: data.searchDisclaimer}}></span> :
          <span dangerouslySetInnerHTML={{__html: data.detailDisclaimer}}></span>
        }
      </p>
    );
  }

  render() {
    return (
      <div className="idx-reqs">
        {this.getDisclaimers()}
      </div>
    );
  }
}

IdxReqs.propTypes = {
  config: PropTypes.object.isRequired,
  listing: PropTypes.object,
  mlsOrgs: PropTypes.array
}

export default IdxReqs;


// WEBPACK FOOTER //
// ./src/components/shared/idx/idx-reqs.js